import { render, staticRenderFns } from "./RemainingVariableIncome.vue?vue&type=template&id=6ec20793&scoped=true&"
import script from "./RemainingVariableIncome.vue?vue&type=script&lang=js&"
export * from "./RemainingVariableIncome.vue?vue&type=script&lang=js&"
import style0 from "./RemainingVariableIncome.vue?vue&type=style&index=0&id=6ec20793&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec20793",
  null
  
)

export default component.exports